import intl from 'react-intl-universal'
import { LOCALE } from '@foxrenderfarm/internals'
import { MainLink, getLocalAppOrigin, getResourceSectionTitle } from '../../light-dropdowns/common'
import { MobileNavAccordion } from '../mobile-nav-accordion'

interface ResourcesPanelProps {
  currentLocale: LOCALE
  origin: string
}

export const ResourcesPanel = ({ currentLocale, origin }: ResourcesPanelProps) => {
  const useGatsby = process.env.GATSBY_PACKAGE_NAME === 'main'
  const useNews = process.env.GATSBY_PACKAGE_NAME === 'news'
  const useShare = process.env.GATSBY_PACKAGE_NAME === 'share'
  const pathLocale = currentLocale === LOCALE.EN ? '' : `/${currentLocale}`
  const mainOrigin = getLocalAppOrigin(origin, 8084)
  const newsOrigin = getLocalAppOrigin(origin, 9000)
  const shareOrigin = getLocalAppOrigin(origin, 8086)

  const contentHub = [
    {
      label: intl.get('index.header.resources.blog'),
      to: '/share/index/',
      href: `${shareOrigin}/share/index/`,
      useGatsbyLink: useShare,
    },
    {
      label: intl.get('index.header.resources.news'),
      to: '/news/main/',
      href: `${newsOrigin}/news/main/`,
      useGatsbyLink: useNews,
    },
    {
      label: intl.get('index.header.resources.customerWorks'),
      to: '/client-works.html',
      href: `${mainOrigin}/client-works.html`,
      useGatsbyLink: useGatsby,
    },
  ]

  const programs = [
    {
      label: intl.get('index.footer.program.goCloud'),
      to: `${pathLocale}/gocloud-program.html`,
    },
    {
      label: intl.get('index.footer.program.goCreation'),
      to: `${pathLocale}/gocreation-program.html`,
    },
    {
      label: intl.get('index.footer.program.goSpark'),
      to: `${pathLocale}/free-render-farm.html`,
    },
    {
      label: intl.get('index.footer.program.referral'),
      to: `${pathLocale}/invite.html`,
    },
  ]

  return (
    <>
      <MobileNavAccordion title={getResourceSectionTitle(currentLocale, 'contentHub')} nested>
        {contentHub.map((item) => {
          if (item.to) {
            return (
              <MainLink
                key={item.label}
                to={item.to}
                href={item.href}
                useGatsbyLink={item.useGatsbyLink ?? useGatsby}
                locale={currentLocale}
              >
                {item.label}
              </MainLink>
            )
          }

          return null
        })}
      </MobileNavAccordion>

      <MobileNavAccordion title={getResourceSectionTitle(currentLocale, 'programsPerks')} nested>
        {programs.map((item) => (
          <MainLink
            key={item.label}
            to={item.to}
            href={`${mainOrigin}${item.to}`}
            useGatsbyLink={useGatsby}
            locale={currentLocale}
          >
            {item.label}
          </MainLink>
        ))}
      </MobileNavAccordion>
    </>
  )
}
